import {Dropdown} from './dropdown';

export enum CivilStatus {
  SINGLE = 'Single',
  RELATIONSHIP = 'Relationship',
  MARRIED = 'Married',
  DIVORCED = 'Divorced',
  WIDOW = 'Widow',
}

export function hasPartner(civilStatus: CivilStatus): boolean {
  return civilStatus === CivilStatus.RELATIONSHIP || civilStatus === CivilStatus.MARRIED;
}

const CIVIL_STATUS_OPTIONS_FR: Dropdown<CivilStatus>[] = [
  {name: 'Célibataire', value: CivilStatus.SINGLE},
  {name: 'Conjoint de fait', value: CivilStatus.RELATIONSHIP},
  {name: 'Marié', value: CivilStatus.MARRIED},
  {name: 'Divorcé', value: CivilStatus.DIVORCED},
  {name: 'Veuf', value: CivilStatus.WIDOW},
];

const CIVIL_STATUS_OPTIONS_EN: Dropdown<CivilStatus>[] = [
  {name: 'Single', value: CivilStatus.SINGLE},
  {name: 'Common-law partner', value: CivilStatus.RELATIONSHIP},
  {name: 'Married', value: CivilStatus.MARRIED},
  {name: 'Divorced', value: CivilStatus.DIVORCED},
  {name: 'Widowed', value: CivilStatus.WIDOW},
];

export const CIVIL_STATUS_OPTIONS = {
  en: CIVIL_STATUS_OPTIONS_EN,
  fr: CIVIL_STATUS_OPTIONS_FR,
};
